 
import{ React} from 'react';

import {Link} from "react-router-dom";

import aca from '../../image/aca.png'
import home from '../../image/home.png'

import cer from '../../image/cer.png'

import fol from '../../image/fol.png'

import eee from '../../image/eee.png'

    


//for navbar show press on off
var val=false;
const navshow=()=>{
  var t=document.getElementById("collapseExample1");
  if(val===false){
    t.style.display='block';
    val=true;
  }
 else{
  t.style.display='none';
   val=false
 }
}


 
window.onscroll = ()=> {
  if(val===true){
    if (window.pageYOffset >= 10) {
      try{
        var t=document.getElementById("collapseExample1");
        t.style.display='none';
        val=false 
      }catch{}
    }else{}
  }
};   
     



function Nav(){
return  (           

<>
<div class="sticky">
<a class="navbar-brand " style={{position:"relative", transform:"rotate(-20deg)", marginTop:'10px', marginBottom:'50px'}}  href="https://ebrahim.rf.gd/"><img src={eee} alt={""} /></a>
    
<div class="navbariconalign "> 
<div></div>
        <Link to="/"> <span class="icon1"><img src={home} alt={""}/>Home   
        </span></Link>
        <Link to="/."> <span class="icon1"><img src={aca} alt={""} />About me</span></Link>

        <Link to="/   "><span class="icon3">  <img src={fol} alt={""}/>Project</span>     
        </Link>
        <Link to="/.."><span class="icon2"> <img src={cer} alt={""}/>Certificate</span>   
        </Link>                          
                 
</div>
</div>
 


{/* for small screen*/}
<div class="sticky1">
 <nav class="navbar navbar-expand-lg" style={{background:'linear-gradient(to right, #F0FDFF, #FFF8F8 80%)'}}>
<a class="navbar-brand " style={{position:"relative", transform:"rotate(-20deg)", marginTop:'10px', marginBottom:'50px'}}  href="https://ebrahim.rf.gd/"><img src={eee} alt={""}/></a>
    
 
<button class="navbar-toggler" onClick={()=>{navshow()}}  >  
    <span class="icon4"   data-toggle="collapse"  > <img src="https://img.icons8.com/material-outlined/30/000000/menu--v1.png" alt={""}/>
    </span>
</button>


</nav>

</div>             
{/*<span class="icon4"  data-toggle="collapse" href="#collapseExample1" role="button" aria-expanded="false" aria-controls="collapseExample"> <img src="https://img.icons8.com/material-outlined/30/000000/menu--v1.png"/>
</span>    
*/}

<div class="card" style={{display:'none',  zIndex:'999',background:'linear-gradient(to right, #F0FDFF, #FFF8F8 80%)', border:'none', position:'fixed', width:'100%'}} id="collapseExample1">
 <div class="card-body" >  
   
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0 ">
          <li class="nav-item">
            <Link to="/"> <span class="navicon1"><img src={home} alt={""} />Home   
          </span></Link>
          </li>

          <li class="nav-item">
          <Link to="/."> <span class="navicon1"><img src={aca} alt={""}/>About me</span></Link>
          </li>

          <li class="nav-item">
            <Link to="/   "><span class="navicon1">  <img src={fol} alt={""}/>Project</span>     
            </Link>
          </li>

            <li class="nav-item">             
            <Link to="/.."><span class="navicon1"> <img src={cer} alt={""}/>Certificate</span>   
            </Link>
                      
          </li>
      </ul>  
</div>

</div>

</>

)}     


export default Nav;   





 
